import { ContentfulModule, Color, ContentfulCollection } from 'libs/contentful/types';
import { Margins } from 'types/constants';
import { liveUpdateAttrs } from 'libs/contentful/utils';
import { CardCarousel } from 'components/shared/Card/CardCarousel';
import { ExtendedCardType } from './types';
import Card from './Card';

export interface BaseCardCarouselProps extends Omit<ContentfulModule, 'name' | 'schema' | '__typename'> {
  color: Color;
  cardStyle: string;
  cardItems: ContentfulCollection<ExtendedCardType>;
  margins: Margins;

  testId?: string;
}

const BaseCardCarousel = ({
  sys,
  color,
  cardStyle,
  cardItems,
  margins,
  sectionName,
  testId,
}: BaseCardCarouselProps) => {
  const testFixture = testId ?? 'base-card-carousel';

  return (
    <section
      className="w-full"
      {...(sectionName != null && { id: encodeURIComponent(sectionName) })}
      {...liveUpdateAttrs(sys?.id, 'content')}>
      <CardCarousel totalItems={cardItems.items.length} color={color.name} margins={margins} sectionName={sectionName}>
        {cardItems.items.map((item, i) => (
          <Card
            key={`card-image-item-${item?.sys?.id ?? i}`}
            index={i}
            total={cardItems.items.length}
            card={item}
            cardStyle={cardStyle}
            testId={testFixture}
          />
        ))}
      </CardCarousel>
    </section>
  );
};

export default BaseCardCarousel;
